import MegaMenu from '../__header/MegaMenu';
import MobileHeader from '../__header/mobileHeader';
import Accordion from '../__shortcodes/accordions';
import mirrorHover from '../__utils/mirrorHover';
import Video from '../__utils/video';
import smoothScroll from '../__utils/smoothScroll';
import Tables from '../__utils/tables';
import Forms from '../__utils/forms';
import vhUnit, { headerHeightVar } from '../__utils/vhUnit';
import AlertBar from '../__header/AlertBar';
import { footerAddFormAnimationClass } from '../__page/footerFormsAnimation';
import cookiesAlert from '../__utils/cookiesAlert';
import { animateIn } from '../__page/animateIn';
import { animateCoreElements } from '../__page/animateCoreElements';

const headerMobile = new MobileHeader();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		footerAddFormAnimationClass();
		MegaMenu.init();
		headerMobile.init();
		Accordion.init();
		Video.init();
		mirrorHover();
		smoothScroll();
		headerHeightVar();
		Tables.init();
		vhUnit();
		AlertBar();
		cookiesAlert();
		animateCoreElements();
		animateIn();
	},
	loaded() {
		document.querySelector('body').classList.add('page-has-loaded');
		Forms();
		vhUnit();
		headerHeightVar();
	},
	resized() {
		headerMobile.resized();
		Tables.toggleShadow();
		vhUnit();
		headerHeightVar();
		// Due to the fact that the header has different transitions, we have to delay the check of its height.
		setTimeout(() => {
			headerHeightVar();
		}, 1000);
	},
	scrolled() {},
	keyDown() {},
	mouseUp(e) {
		headerMobile.hideOutsideClick(e);
	},
	gformRender() {
		footerAddFormAnimationClass();
	},
};
export default controller;
